// @ts-strict-ignore
import {MetricEntry} from 'common/query-builder/query-entry-section/types';
import {
  ConversionWindowUnit,
  FunnelOrder,
  FunnelReentryModeType,
  FUNNELS_MATH_TYPES,
  MetricType,
  TopLevelMetricType,
} from 'common/types/reports/bookmark';
import {RestrictEntitySaving} from 'common/report/constants';
import {getAllSavedBehaviors} from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/behavior-utils';
import {BehaviorsResource} from 'common/report/model-resources/behaviors';
import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {getEmptyEventMetricEntryBehavior} from 'common/query-builder/query-entry-section/row-types/new-metric-entry/utils';

export function hasSavedFunnelBehaviors({behaviors}: {behaviors: BehaviorsResource}): boolean {
  const savedBehaviors = getAllSavedBehaviors({behaviors, metricType: MetricType.Funnel});
  return savedBehaviors.length > 0;
}

export function canSaveForPlan(currentProject: CurrentProject): boolean {
  return Boolean(currentProject?.canSaveEntity(RestrictEntitySaving.BehaviorMetrics));
}

export function getNewEntry({
  isExpanded,
  firstClassMetricsEnabled,
  defaultToConversionSession = false,
  defaultToMathSession = false,
}: {
  isExpanded: boolean;
  firstClassMetricsEnabled?: boolean;
  defaultToConversionSession?: boolean;
  defaultToMathSession?: boolean;
}): MetricEntry {
  return {
    type: firstClassMetricsEnabled ? TopLevelMetricType.NewMetricEntry : TopLevelMetricType.MetricEntry,
    behavior: {
      type: MetricType.Funnel,
      name: null,
      conversionWindowDuration: defaultToConversionSession ? 1 : 7,
      conversionWindowUnit: defaultToConversionSession ? ConversionWindowUnit.Session : ConversionWindowUnit.Day,
      funnelReentryMode: FunnelReentryModeType.Basic,
      funnelOrder: FunnelOrder.Loose,
      aggregateBy: [],
      behaviors: [getEmptyEventMetricEntryBehavior(), getEmptyEventMetricEntryBehavior()],
    },
    measurement: {
      aggregationOperator: defaultToMathSession
        ? FUNNELS_MATH_TYPES.SESSION
        : FUNNELS_MATH_TYPES.CONVERSION_RATE_UNIQUE,
      stepIndex: null,
    },
    isExpanded,
  };
}
